if (!customElements.get('mo-weekends-native')) {
  customElements.define('mo-weekends-native', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.root = this.closest('product-info');
      this.form = document.getElementById(this.dataset.form);
      if (!this.form || !this.root) return;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.boxes = [...this.querySelectorAll('input[type="checkbox"]')];
      this.button = this.form.querySelector('[name="add"]');
      this.price = document.getElementById(`price-${this.dataset.section}`);
      this.inventory = document.getElementById(`Inventory-${this.dataset.section}`);
      this.sku = document.getElementById(`Sku-${this.dataset.section}`);
      this.preorderNote = document.getElementById(`CckPreorder-${this.dataset.section}`);
      this.preorderProperty = document.getElementById(`CckPreorderProperty-${this.dataset.section}`);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      const variantId = new URL(location.href).searchParams.get('variant');
      const initial = this.variants.find(v => String(v.id) === variantId);
      if (initial && typeof initial.sku === 'string') {
        const codes = initial.sku.split('-').slice(1);
        this.boxes.forEach(b => { b.checked = b.dataset.available === 'true' && codes.includes(b.dataset.code); });
      }
      this.addEventListener('change', e => {
        if (e.target.type !== 'checkbox') return;
        if (this.chosen().length > 4) e.target.checked = false;
        this.update();
      });
      this.form.addEventListener('submit', e => {
        const variant = this.match();
        if (!variant || !variant.available) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true);
      this.update();
    }
    chosen() { return this.boxes.filter(b => b.checked); }
    match() {
      const chosen = this.chosen();
      if (chosen.length !== 4) return null;
      const key = chosen.map(b => b.dataset.code).sort().join('|');
      return this.variants.find(v => typeof v.sku === 'string' && v.sku.split('-').slice(1).sort().join('|') === key);
    }
    update() {
      const chosen = this.chosen();
      const variant = this.match();
      const ready = Boolean(variant && variant.available);
      const preorder = variant ? variant.preorder === true : this.dataset.preorderActive === 'true' && chosen.some(b => b.dataset.code === 'CCK');
      if (this.preorderNote) this.preorderNote.hidden = !preorder;
      if (this.preorderProperty) this.preorderProperty.disabled = !ready || !preorder;
      this.boxes.forEach(b => { b.disabled = b.dataset.available !== 'true' || (chosen.length === 4 && !b.checked); });
      this.querySelector('[data-count]').textContent = String(chosen.length);
      this.querySelector('[data-status]').textContent = variant ? (ready ? (preorder ? this.dataset.preorderStatus : this.dataset.ready) : this.dataset.unavailable) : this.dataset.choose;
      this.root.querySelectorAll('input[name="id"]').forEach(input => { input.value = variant ? variant.id : ''; input.disabled = !ready; });
      this.button.disabled = !ready;
      this.button.setAttribute('aria-disabled', String(!ready));
      this.button.querySelector('span').textContent = variant ? (ready ? (preorder ? this.dataset.preorderAdd : this.dataset.add) : this.dataset.unavailable) : this.dataset.choose;
      const prices = this.variants.map(v => v.price);
      const label = variant ? this.money.format(variant.price / 100) : `${this.money.format(Math.min(...prices) / 100)} – ${this.money.format(Math.max(...prices) / 100)}`;
      this.price?.querySelectorAll('.price-item--regular').forEach(el => { el.textContent = label; });
      this.price?.querySelector('.price')?.classList.toggle('price--sold-out', Boolean(variant && !ready));
      this.price?.querySelectorAll('.badge').forEach(el => {
        el.hidden = el.hasAttribute('data-preorder-badge') ? !preorder || Boolean(variant && !ready) : ready || !variant;
        if (el.classList.contains('price__badge-sold-out')) el.textContent = preorder ? this.dataset.preorderClosed : this.dataset.soldOut;
      });
      if (this.inventory) {
        this.inventory.hidden = !variant;
        this.inventory.textContent = variant ? (ready ? (preorder ? this.dataset.preorderShipping : (variant.quantity > 0 ? this.dataset.stock.replace('COUNT', variant.quantity) : this.dataset.backorder)) : (preorder ? this.dataset.preorderClosed : this.dataset.out)) : '';
      }
      if (this.sku) { this.sku.hidden = !variant; if (variant) this.sku.textContent = variant.sku; }
      const quantity = this.root.querySelector('input[name="quantity"]');
      if (quantity && variant) {
        if (variant.quantity > 0) {
          quantity.max = String(variant.quantity);
          quantity.dataset.max = String(variant.quantity);
        } else {
          quantity.removeAttribute('max');
          delete quantity.dataset.max;
        }
      }
      if (variant) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
  });
}
